import type { SxProps, Theme } from '@mui/material/styles';

export function toSxArray(sx?: SxProps<Theme>) {
  if (sx === undefined) {
    return [];
  }
  return Array.isArray(sx) ? sx : [sx];
}
